import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-search-md',
  standalone: true,
  templateUrl: './rt-icon-search-md.component.html',
  styleUrls: ['./rt-icon-search-md.component.scss']
})
export class RtIconSearchMdComponent {
  @Input() width: number | string = 15;
  @Input() height: number | string = 15;
}
